import { useMutation } from "@tanstack/react-query";
import { useCurrentProfileSet } from "PFCore/hooks/queries/profile";
import { editCurrentProfile } from "PFCore/services/current_profile";
import { CurrentProfile } from "PFTypes";
import { MutationOptions } from "PFTypes/request_options";

import { useProfileInvalidate } from "./use_profile_invalidate";

export const useCurrentProfileUpdate = ({
  onSuccess,
  ...queryParams
}: MutationOptions<Partial<CurrentProfile>> = {}) => {
  const setCurrentProfile = useCurrentProfileSet();
  const { invalidateSuggestedProfile } = useProfileInvalidate();

  return useMutation({
    mutationFn: (payload: Partial<CurrentProfile>): any => editCurrentProfile(payload),
    onSuccess: (resp: CurrentProfile, ...params) => {
      setCurrentProfile(resp);
      invalidateSuggestedProfile(resp.id);
      onSuccess?.(resp, ...params);
    },
    ...queryParams
  });
};
